/* Dansk katalog for locale-closing-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'route.arsavslutning-kjop': 'Køb og bilag',
  'clo.purchases.title': 'Køb og bilag',
  'clo.purchases.year': 'Indkomstår {{year}}',
  'clo.purchases.subtitle': 'Følg op på køb og bilag for indkomståret {{year}}.',
  'clo.purchases.pending': '{{count}} køb eller bilag skal behandles, før købskontrollen for {{year}} er klar.',
  'clo.purchases.ready': 'Ingen ubehandlede køb eller manglende købsbilag fundet for {{year}}.',
  'clo.purchases.unsupported': 'Købskontrollen understøttes ikke for dette land, regelsæt eller år.',
  'clo.purchases.purchaseIssues': 'Køb, der skal følges op',
  'clo.purchases.missingTitle': 'Transaktioner, der mangler bilag ({{count}})',
  'clo.purchases.missingSummary': 'Tilføj den dokumentation, der hører til hver transaktion.',
  'clo.purchases.reviewMissing': 'Vis og tilføj bilag',
  'clo.purchases.documentsModalTitle': 'Manglende bilag',
  'clo.purchases.missingHelp': 'Træk et bilag til den rigtige linje, eller upload det.',
  'clo.purchases.missingDateAction': 'Mangler gyldig dato – åbn transaktionen for at vælge år',
  'clo.purchases.upload': 'Upload bilag',
  'clo.purchases.uploading': 'Uploader …',
  'clo.purchases.uploaded': 'Bilaget er tilføjet.',
  'clo.purchases.uploadLater': 'Upload bilag senere',
  'clo.purchases.uploadError': 'Kunne ikke uploade bilaget.',
  'clo.purchases.noMissingDocumentation': 'Alle transaktioner har bilag.',
  'clo.purchases.deferredHelp': 'Bilag uploades senere. Du kan fortsætte gennemgangen, men bilagene skal tilføjes, før året afsluttes.',
  'clo.purchases.inboxSideHelp': 'Her ligger de bilag, der ikke er bogført endnu.',
  'clo.purchases.inboxInteractionHint': 'Åbn et bilag for at kontrollere det.',
  'clo.purchases.continueWithoutInbox': 'Fortsæt uden behandling',
  'clo.purchases.continueConfirmTitle': 'Ikke relevant for årsafslutningen?',
  'clo.purchases.continueConfirmText': 'Bekræft, at de {{count}} ubehandlede bilag ikke er relevante for købskontrollen i {{year}}. De bliver liggende i indbakken, men blokerer ikke denne årsafslutning.',
  'clo.purchases.inboxExcluded': 'Bilagene er vurderet som ikke relevante for denne årsafslutning.',
  'clo.purchases.excludeError': 'Kunne ikke gemme vurderingen.',
  'clo.purchases.noPurchaseIssues': 'Ingen åbne afvigelser på registrerede køb.',
  'clo.purchases.missingDocumentation': 'Mangler bilag',
  'clo.purchases.lostDocumentation': 'Bilaget er meldt bortkommet. Afvigelsen er logget, men købet mangler stadig dokumentation.',
  'clo.purchases.draft': 'Købskladde skal færdigbehandles',
  'clo.purchases.undated': 'Mangler gyldig dato. Afklar, hvilket år posten hører til.',
  'clo.purchases.unknownDate': 'Mangler gyldig dato',
  'clo.purchases.inboxTitle': 'Ubehandlede bilag ({{count}})',
  'clo.purchases.inboxScope': 'Behandl de bilag, der hører til {{year}}, eller fortsæt, hvis de ikke er relevante for denne årsafslutning.',
  'clo.purchases.scopeHelp': 'En ubetalt leverandørfaktura kan være færdigbogført. Betaling, momsafstemning og periodisering kontrolleres i separate trin. Klar her betyder, at de registrerede køb og indbakken har bestået denne kontrol.',
  'clo.purchases.openPurchase': 'Åbn købet',
  'clo.purchases.openInbox': 'Behandl bilag i indbakken',
  'clo.purchases.back': 'Tilbage til købskontrollen',
  'clo.purchases.backToClosing': 'Tilbage til årsafslutning',
  'clo.purchases.loadError': 'Kunne ikke åbne købsvisningen.',
  'clo.payables.title': 'Leverandørgæld',
  'clo.payables.itemsTitle': 'Åbne leverandørposter pr. 31.12.{{year}}',
  'clo.payables.itemsHelp': 'Leverandørfakturaer, der stod åbne ved årsskiftet, også fra tidligere år. Senere betalinger vises separat og ændrer ikke saldoen pr. 31.12.',
  'clo.payables.supplier': 'Leverandør og dokument',
  'clo.payables.date': 'Dokumentdato og forfald',
  'clo.payables.openAmount': 'Åbent ved årsskiftet',
  'clo.payables.followUp': 'Opfølgning',
  'clo.payables.paidAfterAmount': 'Betalt efter årsskiftet: {{amount}}',
  'clo.payables.balanceTitle': 'Afstemning mod hovedbogen',
  'clo.payables.assessmentTitle': 'Vurdering og godkendelse',
  'clo.payables.reviewHelp': 'Vurdér posterne med afkrydsning i tabellen, før du godkender kontrollen.',
  'clo.payables.saveAssessment': 'Gem vurdering',
  'clo.payables.help': 'Hovedbog og åbne leverandørposter pr. 31.12.{{year}} sammenlignes automatisk.',
  'clo.payables.ledger': 'Hovedbog',
  'clo.payables.subledger': 'Kreditorbog',
  'clo.payables.difference': 'Difference',
  'clo.payables.needsReview': 'Skal vurderes ({{count}})',
  'clo.payables.allOpen': 'Alle åbne poster ({{count}})',
  'clo.payables.due': 'Forfald {{date}}',
  'clo.payables.noDueDate': 'Ingen forfaldsdato',
  'clo.payables.open': 'Åbn transaktionen',
  'clo.payables.reviewed': 'Vurderet',
  'clo.payables.noRows': 'Ingen åbne poster i dette udvalg.',
  'clo.payables.cutOffQuestion': 'Er der varer eller tjenesteydelser modtaget før 31.12.{{year}}, som endnu ikke er bogført?',
  'clo.payables.cutOffHelp': 'Dette er den del, Plumme ikke kan afgøre ud fra bogførte data alene.',
  'clo.payables.cutOffNo': 'Nej, alt er bogført',
  'clo.payables.cutOffYes': 'Ja, noget mangler',
  'clo.payables.unrecordedHelp': 'Registrér de manglende køb, før kontrollen kan gennemføres.',
  'clo.payables.complete': 'Godkend kontrol',
  'clo.payables.saved': 'Leverandørgælden er kontrolleret.',
  'clo.payables.saveError': 'Kunne ikke gemme kontrollen.',
  'clo.payables.reason.reconciled': 'Afstemt',
  'clo.payables.reason.notApplicable': 'Ingen leverandørgæld ved årets udgang.',
  'clo.payables.reason.unsupported': 'Kontrollen understøttes ikke for dette land, regelsæt eller år.',
  'clo.payables.reason.stale': 'Talgrundlaget er ændret. Kontrollér posterne igen.',
  'clo.payables.reason.ledgerDifference': 'Hovedbog og kreditorbog stemmer ikke.',
  'clo.payables.reason.missingDocument': 'En åben leverandørpost mangler bilag.',
  'clo.payables.reason.invalidDate': 'En leverandørfaktura mangler gyldig dato.',
  'clo.payables.reason.basisReviewRequired': 'Kontogrundlaget skal kontrolleres.',
  'clo.payables.reason.cutOffRequired': 'Én oplysning skal afklares.',
  'clo.payables.reason.unrecordedItems': 'Manglende køb skal bogføres.',
  'clo.payables.reason.exceptionsRequired': 'Vurdér de markerede poster.',
  'clo.payables.reason.reviewRequired': 'Kontrollen skal gennemføres.',
  'clo.payables.issue.ledgerDifference': 'Differencen skal rettes i bogføringen, før kontrollen kan gennemføres.',
  'clo.payables.issue.missingDocument': 'Tilføj bilag til åbne poster, der mangler dokumentation.',
  'clo.payables.issue.invalidDate': 'Åbn leverandørfakturaen, og registrér den korrekte fakturadato.',
  'clo.payables.issue.basisReviewRequired': 'Plumme kan ikke beregne et sikkert kontogrundlag for denne virksomhed.',
  'clo.payables.flag.old': 'Over 90 dage gammel',
  'clo.payables.flag.overdue': 'Forfaldet over 30 dage',
  'clo.payables.flag.negative': 'Negativ saldo',
  'clo.payables.flag.duplicate': 'Mulig dublet',
  'clo.payables.flag.currency': 'Valutapost',
  'clo.payables.flag.missingDocument': 'Mangler bilag',
  'clo.payables.flag.paidAfter': 'Betalt efter årets udgang',
});
